import React from 'react';
import ReactSlider from 'react-slider';
import style from './TimeSlider.css';
function toTime(t, start, stop) {
    return start + (t / 100.0) * (stop - start);
}
function fromTime(time, start, stop) {
    return (100.0 * (time - start)) / (stop - start);
}
export default class TimeSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false,
        };
    }
    toggleHover() {
        this.setState({ hover: !this.state.hover });
    }
    render() {
        return (React.createElement("div", { className: `${style.sliderContainer} ${this.state.hover ? style.hover : ''}`, onMouseEnter: () => this.toggleHover(), onMouseLeave: () => this.toggleHover() },
            React.createElement(ReactSlider, { className: style.slider, handleClassName: style.sliderThumb, barClassName: style.sliderBar, step: 0.01, value: fromTime(this.props.time, this.props.startTime, this.props.stopTime), onBeforeChange: () => this.props.pause(), onAfterChange: () => this.props.resume(), onChange: t => this.props.setTime(toTime(t, this.props.startTime, this.props.stopTime)), withBars: true })));
    }
}
